"use client";

import { c as _c } from "react/compiler-runtime";
import { AIChatMessageContext, type AIChatMessageContextValue } from "../contexts";
import type { ChatMessage } from "../types";
import { useMemo } from "react";
interface AIChatMessageProps {
  message: ChatMessage;
  index: number;
  children: React.ReactNode;
  className?: string;
}
export function AIChatMessage(t0) {
  const $ = _c(9);
  const {
    message,
    index,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== index || $[1] !== message) {
    t1 = {
      message,
      index
    };
    $[0] = index;
    $[1] = message;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const value = t1;
  let t2;
  if ($[3] !== children || $[4] !== className) {
    t2 = <div className={className}>{children}</div>;
    $[3] = children;
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2 || $[7] !== value) {
    t3 = <AIChatMessageContext value={value}>{t2}</AIChatMessageContext>;
    $[6] = t2;
    $[7] = value;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}